export default [
  {
    path: "/integrations-setting",
    name: "IntegrationsSetting",
    component: () =>
      import("@/views/Page/IntegrationsSetting/IntegrationsSetting.vue"),
    meta: {
      title: "Integrations Setting",
      requiresAuth: true,
    },
  },
];
